/**
 * DESIGNER PREVIEW - Canvas-basierte Live-Vorschau
 * Zeigt personalisierte Blumentopf-Designer-Produkte mit Echtzeit-Rendering
 * 4 Textzeilen + 108 Icons in Kategorien + 6 Schriftarten
 */

const DesignerPreview = {
  // ========================================
  // KONFIGURATION
  // ========================================
  config: {
    // Base-Produktbild (Blumentopf ohne Gravur)
    // Pro Produkt ueberschreibbar (window.DESIGNER_BASE_IMAGE im Template
    // setzen) - Standard bleibt fuer alle bestehenden Designer-Produkte
    baseImage: window.DESIGNER_BASE_IMAGE
      || 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/vorschaubild.png?v=1761572868',

    // Canvas-Dimensionen
    canvasWidth: 800,
    canvasHeight: 800,

    // Icon-URLs (1-108) mit Kategorien
    iconCategories: {
      'Liebe & Hochzeit': [2, 4, 5, 6, 7, 44, 45, 46, 47, 49, 94, 104, 105, 106, 107],
      'Geburt, Baby & Schwangerschaft': [3, 31, 32, 34, 35, 48, 54, 55],
      'Familie & Elterntage': [33, 50, 51, 52, 53, 56, 57, 58, 59, 60],
      'Freundschaft': [99],
      'Glaube & Kirche': [100, 101, 102, 103],
      'Feiertage & Saison': [10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 30, 96],
      'Feiern & Party': [1, 29, 92],
      'Schule/Kindergarten/Abschluss': [41, 42, 68, 69, 97],
      'Haus & Einzug': [39, 40],
      'Tiere & Haustiere': [25, 61, 62, 63, 70, 71, 72, 73, 74, 75, 76],
      'Kinder & Fantasie': [64, 65, 66, 67, 98],
      'Natur, Pflanzen & Himmel': [8, 9, 22, 36, 37, 38, 78],
      'Reise, Outdoor & Fahrzeuge': [24, 26, 43, 86, 88, 89, 91]
    },

    // Icon-URLs (108 Icons)
    iconUrls: {
      1: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/1_ac8c68d4-d49e-4f28-b7d5-498f0749aa97.png?v=1761951782',
      2: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/2_20168f79-48f0-42e3-8d38-5c821e275f29.png?v=1761951782',
      3: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/3_ae65d0e1-0dff-4649-84b9-7720d40f5ba3.png?v=1761951784',
      4: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/4_9a47ac38-55cd-4ad8-9b22-39351feebc24.png?v=1761951782',
      5: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/5_4dabbeeb-7f57-4562-97af-dcf0b6f0e4d2.png?v=1761951781',
      6: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/6_0ae0cd09-4de5-40d7-8877-d5cf700f9f7a.png?v=1761951782',
      7: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/7_a510ae62-40a6-4568-8d32-772e54fe42bd.png?v=1761951783',
      8: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/8_081c6f0f-6909-4b29-8434-2b13559d5031.png?v=1761951783',
      9: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/9_551392c2-6391-4d04-99a3-d192882d8a0f.png?v=1761951783',
      10: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/10_c2463a99-8332-489b-85f3-692b6f4b435e.png?v=1761951782',
      11: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/11_4c590b00-812b-4918-b117-261a0e01f645.png?v=1761951783',
      12: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/12_d2606f2c-a0f3-4c1d-9139-8a3b5c24a780.png?v=1761951783',
      13: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/13_5cd90892-4392-40fb-b22e-bd11d7201d85.png?v=1761951782',
      14: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/14_af8d1352-23d9-4f05-b363-2f7224f80869.png?v=1761951784',
      15: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/15_573f68e1-58eb-44ce-83c2-bdd319c023bb.png?v=1761951782',
      16: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/16_48823ec3-e8d8-4f8a-8e31-9170a459c1f8.png?v=1761951782',
      17: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/17_95fc5429-2d59-4a14-a74d-783823f839d2.png?v=1761951783',
      18: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/18_b5ff2144-17c4-40d3-ae57-cc1d9cb918e9.png?v=1761951782',
      19: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/19_f3d0e062-b031-436e-8fc3-404def021c66.png?v=1761951783',
      20: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/20_e7988aa9-7862-4158-a0a7-8af1fc36ae2d.png?v=1761951783',
      21: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/21_c8e4b819-2094-4757-97fb-095b3ba4f401.png?v=1761951783',
      22: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/22_409f6ac9-6674-43f7-ab37-2831645c0108.png?v=1761951783',
      23: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/23_00c9a1d1-8925-4818-8481-7e6d66fbfa1f.png?v=1761951781',
      24: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/24_fd1721ce-dc70-4a59-bfbb-e5406601ea5f.png?v=1761951782',
      25: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/25_49fd31dc-e782-457b-93e1-95b0d6703c47.png?v=1761951784',
      26: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/26_5af89679-6d58-4663-97a9-17ccd85a3869.png?v=1761951784',
      27: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/27_97e1745e-8fa8-4dce-975c-c5bd51e20c96.png?v=1761951783',
      28: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/28_057782bc-d29a-4b52-84e8-cd8921f27db1.png?v=1761951783',
      29: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/29_cdea3cc6-978f-4e74-af5a-e28292188ad5.png?v=1761951782',
      30: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/30_b67bab52-6f03-4a12-b752-3c951866145b.png?v=1761951783',
      31: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/31_99374c98-62b5-4f6d-b3d3-5f895057bb48.png?v=1761951783',
      32: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/32_7f79bae8-52fd-433b-b83f-0d1f6b0943b2.png?v=1761951783',
      33: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/33_57859fb8-ec97-499f-a4d0-25d4caa4ec8e.png?v=1761951783',
      34: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/34_6fba103f-1c0c-4ddb-824b-32f64a94384b.png?v=1761951782',
      35: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/35_03ef7663-2203-4bea-ae1c-e03c9fad2db1.png?v=1761951781',
      36: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/36_65ab86c5-d72d-4c0c-8e9a-caf3bb8d5cc7.png?v=1761951782',
      37: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/37_43949f02-6ae0-4dbe-bb35-4cee10178dbd.png?v=1761951784',
      38: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/38_1eef8ed8-ea8d-48c1-bf4d-c9610224a4da.png?v=1761951782',
      39: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/39_255c6587-f138-4194-88fe-e3eb416db1a2.png?v=1761951782',
      40: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/40_ede7af9e-9357-451a-9164-7197f2319cce.png?v=1761951783',
      41: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/41_18beae87-a2d2-4e8d-9a28-2ccf4d89de13.png?v=1761951783',
      42: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/42_eabe8aa0-028b-406d-b85b-c2616efe2504.png?v=1761951783',
      43: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/43_9511d4a4-8728-4224-b534-f42e05db4f1d.png?v=1761951783',
      44: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/44_ccb16da2-9290-4dba-b04e-369752061fb7.png?v=1761951783',
      45: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/45_1e2cde04-f146-440d-8594-de4a76c3ffd3.png?v=1761951783',
      46: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/46_4e133ec0-30f2-49a2-bb1e-a31d6b09003f.png?v=1761951783',
      47: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/47_7e4d2d42-fbfe-4010-a8d2-2583ded4f8ca.png?v=1761951782',
      48: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/48_8f8984ca-e1cb-406c-afa6-462ae069f347.png?v=1761951783',
      49: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/49_0d9aa17e-582e-40f2-8528-f116e69a33a1.png?v=1761951783',
      50: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/50.png?v=1761951783',
      51: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/51.png?v=1761951783',
      52: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/52.png?v=1761951783',
      53: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/53.png?v=1761951784',
      54: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/54.png?v=1761951784',
      55: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/55_876caa1e-b5c1-4ac6-9136-6ecc958b3ac8.png?v=1761951783',
      56: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/56.png?v=1761951782',
      57: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/57.png?v=1761951782',
      58: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/58.png?v=1761951781',
      59: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/59.png?v=1761951783',
      60: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/60.png?v=1761951782',
      61: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/61.png?v=1761951782',
      62: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/62.png?v=1761951782',
      63: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/63.png?v=1761951783',
      64: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/64.png?v=1761951782',
      65: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/65.png?v=1761951783',
      66: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/66.png?v=1761951783',
      67: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/67.png?v=1761951783',
      68: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/68.png?v=1761951783',
      69: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/69_12fd0d4b-78d2-4f41-8a8f-135149b37315.png?v=1761951783',
      70: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/70.png?v=1761951781',
      71: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/71.png?v=1761951782',
      72: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/72.png?v=1761951782',
      73: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/73.png?v=1761951782',
      74: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/74.png?v=1761951782',
      75: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/75.png?v=1761951782',
      76: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/76.png?v=1761951783',
      77: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/77.png?v=1761951784',
      78: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/78.png?v=1761951783',
      79: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/79.png?v=1761951781',
      80: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/80.png?v=1761951784',
      81: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/81.png?v=1761951783',
      82: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/82.png?v=1761951783',
      83: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/83.png?v=1761951781',
      84: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/84.png?v=1761951782',
      85: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/85.png?v=1761951783',
      86: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/86.png?v=1761951782',
      87: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/87.png?v=1761951783',
      88: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/88.png?v=1761951783',
      89: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/89.png?v=1761951784',
      90: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/90.png?v=1761951783',
      91: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/91.png?v=1761951782',
      92: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/92.png?v=1761951783',
      93: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/93.png?v=1761951783',
      94: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/94.png?v=1761951782',
      95: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/95.png?v=1761951782',
      96: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/96.png?v=1761951782',
      97: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/97.png?v=1761951783',
      98: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/98.png?v=1761951782',
      99: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/99.png?v=1761951783',
      100: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/100.png?v=1761951782',
      101: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/101.png?v=1761951782',
      102: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/102.png?v=1761951781',
      103: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/103.png?v=1761951783',
      104: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/104.png?v=1761951783',
      105: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/105.png?v=1761951783',
      106: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/106.png?v=1761951782',
      107: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/107.png?v=1761951782',
      108: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/108.png?v=1761951782'
    },

    // Schriftarten-Konfiguration
    fontConfig: {
      'Pixie Ring': {
        url: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/Pixie_Ring_Regular.ttf?v=1761954704',
        previewImage: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/1_pixie-ring-font-with-illustrations.png?v=1761955108',
        name: 'Pixie Ring'
      },
      'Dreaming Outloud': {
        url: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/dreaming-outloud-allcaps-regular.ttf?v=1761954704',
        previewImage: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/2_dreaming-outloud-allcaps-regular-maisfontes.2e69.png?v=1761955108',
        name: 'Dreaming Outloud'
      },
      'Montserrat': {
        url: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/Montserrat-VariableFont_wght.ttf?v=1761954705',
        previewImage: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/3_Montserrat.png?v=1761955108',
        name: 'Montserrat'
      },
      'Allura': {
        url: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/Allura-Regular.ttf?v=1761954704',
        previewImage: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/4_Allura.png?v=1761955109',
        name: 'Allura'
      },
      'Bebas Neue': {
        url: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/BebasNeue-Regular.ttf?v=1761954704',
        previewImage: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/5_Bebas_Neue.png?v=1761955108',
        name: 'Bebas Neue'
      },
      'Amatic SC': {
        url: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/AmaticSC-Regular.ttf?v=1761954704',
        previewImage: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/6_Amatic_SC.png?v=1761955109',
        name: 'Amatic SC'
      }
    },

    // Text-Positionen (basierend auf Musterbild - 4 Zeilen)
    textConfig: {
      line1: { x: 400, y: 480, fontSize: 52, align: 'center', baseline: 'middle' },
      line2: { x: 400, y: 545, fontSize: 46, align: 'center', baseline: 'middle' },
      line3: { x: 400, y: 610, fontSize: 42, align: 'center', baseline: 'middle' },
      line4: { x: 400, y: 675, fontSize: 38, align: 'center', baseline: 'middle' },
      color: '#4a4a4a' // Dunkelgrau für Gravur-Effekt
    },

    // Icon-Position (oben rechts)
    iconConfig: {
      x: 520,        // Weiter links
      y: 365,        // Oben
      maxWidth: 120,
      maxHeight: 120
    }
  },

  // Interner State
  canvas: null,
  ctx: null,
  liveCanvas: null,
  liveCtx: null,
  images: {
    base: null,
    icon: null
  },
  fontsLoaded: false,
  isRendering: false,
  isLiveRendering: false,
  currentFont: 'Pixie Ring',
  livePreviewScale: 800 / 250, // Skalierung für Live-Preview (3.2)

  /**
   * Initialisierung
   */
  init() {
    // Glossy-Modus: Anderes Vorschaubild verwenden
    if (window.DESIGNER_GLOSSY_MODE) {
      this.config.baseImage = 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/Design_ohne_Titel_66ee0c6a-60fb-4b36-8140-de8eb85a9694.png?v=1766134751';
    }

    this.canvas = document.getElementById('preview-canvas');
    if (!this.canvas) {
      console.error('Canvas element not found');
      return;
    }

    this.ctx = this.canvas.getContext('2d');
    this.setupEventListeners();
    this.loadFonts();
    this.loadBaseImage();
    this.setupCartIntegration();
    this.setupIconCategoryFilter();
    this.initLivePreview();

    console.log('DesignerPreview initialized');
  },

  /**
   * Event Listeners einrichten
   */
  setupEventListeners() {
    // Vorschau-Button
    const previewBtn = document.getElementById('preview-btn');
    if (previewBtn) {
      previewBtn.addEventListener('click', () => this.openPreview());
    }

    // Modal schließen
    const closeBtn = document.querySelector('.preview-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.closePreview());
    }

    // Modal-Hintergrund klicken
    const modal = document.getElementById('preview-modal');
    if (modal) {
      modal.addEventListener('click', (e) => {
        if (e.target.id === 'preview-modal') {
          this.closePreview();
        }
      });
    }

    // ESC-Taste
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closePreview();
      }
    });

    // Schriftart-Auswahl via Radio Buttons
    const fontRadios = document.querySelectorAll('input[name="font-choice"]');
    fontRadios.forEach(radio => {
      radio.addEventListener('change', (e) => {
        const hiddenFont = document.getElementById('designer-font');
        if (hiddenFont) {
          hiddenFont.value = e.target.value;
          this.currentFont = e.target.value;
          console.log('Font changed to:', this.currentFont);
        }
      });
    });
  },

  /**
   * Icon-Kategorie-Filter einrichten (Chip-basiert)
   */
  setupIconCategoryFilter() {
    const chipsContainer = document.getElementById('icon-category-chips');
    if (!chipsContainer) return;

    const chips = chipsContainer.querySelectorAll('.icon-category-chip');

    chips.forEach(chip => {
      chip.addEventListener('click', () => {
        // Aktiven Chip wechseln
        chips.forEach(c => c.classList.remove('active'));
        chip.classList.add('active');

        // Icons filtern
        const category = chip.dataset.category;
        this.filterIconsByCategory(category);
      });
    });

    // Default: "Liebe & Hochzeit" ist bereits aktiv (im HTML), Icons filtern
    this.filterIconsByCategory('Liebe & Hochzeit');

    // Icon 4 vorauswählen
    const icon4 = document.querySelector('input[name="designer-icon"][value="4"]');
    if (icon4) {
      icon4.checked = true;
      icon4.dispatchEvent(new Event('change', { bubbles: true }));
    }
  },

  /**
   * Icons nach Kategorie filtern
   */
  filterIconsByCategory(category) {
    const iconCarousel = document.querySelector('.icon-carousel');
    if (!iconCarousel) return;

    const allIcons = iconCarousel.querySelectorAll('.icon-option');

    if (category === 'all') {
      // Alle Icons anzeigen
      allIcons.forEach(icon => {
        icon.style.display = 'block';
      });
    } else {
      // Nur Icons der gewählten Kategorie anzeigen
      const categoryIcons = this.config.iconCategories[category] || [];

      allIcons.forEach(icon => {
        // Die Kachel "ohne Symbol" gehoert zu keiner Kategorie und muss
        // trotzdem ueberall waehlbar bleiben.
        if (icon.dataset.keinSymbol) {
          icon.style.display = 'block';
          return;
        }
        const iconNumber = parseInt(icon.dataset.iconNumber);
        if (categoryIcons.includes(iconNumber)) {
          icon.style.display = 'block';
        } else {
          icon.style.display = 'none';
        }
      });
    }
  },

  /**
   * Fonts laden
   */
  async loadFonts() {
    try {
      await document.fonts.ready;

      // Alle Schriftarten laden
      for (const [fontName, fontData] of Object.entries(this.config.fontConfig)) {
        await document.fonts.load(`48px "${fontData.name}"`);
      }

      this.fontsLoaded = true;
      console.log('✓ Fonts loaded successfully');
    } catch (error) {
      console.error('Error loading fonts:', error);
      this.fontsLoaded = true;
    }
  },

  /**
   * Base-Bild vorladen
   */
  loadBaseImage() {
    this.images.base = new Image();
    this.images.base.crossOrigin = 'anonymous';

    this.images.base.onload = () => {
      console.log('✓ Base image loaded');
    };

    this.images.base.onerror = () => {
      console.error('✗ Failed to load base image');
    };

    this.images.base.src = this.config.baseImage;
  },

  /**
   * Formulardaten sammeln
   */
  getFormData() {
    // Schriftart aus Hidden Field oder aus ausgewähltem Radio Button
    const selectedFont = document.querySelector('input[name="font-choice"]:checked');
    const fontValue = selectedFont ? selectedFont.value : (document.getElementById('designer-font')?.value || 'Pixie Ring');

    return {
      line1: document.getElementById('designer-line1')?.value || '',
      line2: document.getElementById('designer-line2')?.value || '',
      line3: document.getElementById('designer-line3')?.value || '',
      line4: document.getElementById('designer-line4')?.value || '',
      font: fontValue,
      iconNumber: document.querySelector('input[name="designer-icon"]:checked')?.value || '',
      samen: document.querySelector('input[name="properties[Samenart]"]')?.value || ''
    };
  },

  /**
   * Vorschau öffnen und rendern
   */
  async openPreview() {
    if (this.isRendering) return;

    const formData = this.getFormData();
    const modal = document.getElementById('preview-modal');

    if (modal) {
      modal.style.display = 'flex';
      await this.renderPreview(formData);
    }
  },

  /**
   * Vorschau schließen
   */
  closePreview() {
    const modal = document.getElementById('preview-modal');
    if (modal) {
      modal.style.display = 'none';
    }
  },

  /**
   * Canvas-Vorschau rendern
   */
  async renderPreview(formData) {
    if (this.isRendering) return;
    this.isRendering = true;

    try {
      // Warten auf Fonts
      if (!this.fontsLoaded) {
        await this.loadFonts();
      }

      // Canvas zurücksetzen
      this.ctx.clearRect(0, 0, this.config.canvasWidth, this.config.canvasHeight);

      // 1. Base-Bild zeichnen
      if (this.images.base && this.images.base.complete) {
        this.ctx.drawImage(
          this.images.base,
          0, 0,
          this.config.canvasWidth,
          this.config.canvasHeight
        );
      }

      // 2. Icon zeichnen (wenn ausgewählt)
      if (formData.iconNumber) {
        await this.drawIcon(formData.iconNumber);
      }

      // 3. Textzeilen zeichnen
      await this.drawText(formData);

    } catch (error) {
      console.error('Rendering error:', error);
    } finally {
      this.isRendering = false;
    }
  },

  /**
   * Icon zeichnen
   */
  async drawIcon(iconNumber) {
    const iconUrl = this.config.iconUrls[iconNumber];
    if (!iconUrl) return;

    return new Promise((resolve) => {
      const iconImg = new Image();
      iconImg.crossOrigin = 'anonymous';

      iconImg.onload = () => {
        const iconConfig = this.config.iconConfig;

        // Skalierung berechnen
        let width = iconImg.width;
        let height = iconImg.height;
        const scale = Math.min(
          iconConfig.maxWidth / width,
          iconConfig.maxHeight / height
        );

        width *= scale;
        height *= scale;

        // Icon zeichnen (oben rechts)
        this.ctx.drawImage(
          iconImg,
          iconConfig.x - width / 2,
          iconConfig.y - height / 2,
          width,
          height
        );

        resolve();
      };

      iconImg.onerror = () => {
        console.error('Failed to load icon:', iconNumber);
        resolve();
      };

      iconImg.src = iconUrl;
    });
  },

  /**
   * Text zeichnen (4 Zeilen)
   */
  async drawText(formData) {
    const textConfig = this.config.textConfig;
    const fontData = this.config.fontConfig[formData.font];
    const fontName = fontData ? fontData.name : 'Pixie Ring';

    // Text-Style setzen
    this.ctx.fillStyle = textConfig.color;
    this.ctx.textAlign = 'center';
    this.ctx.textBaseline = 'middle';

    // Alle 4 Zeilen zeichnen
    const lines = [
      { text: formData.line1, config: textConfig.line1 },
      { text: formData.line2, config: textConfig.line2 },
      { text: formData.line3, config: textConfig.line3 },
      { text: formData.line4, config: textConfig.line4 }
    ];

    for (const line of lines) {
      if (line.text) {
        this.ctx.font = `${line.config.fontSize}px "${fontName}"`;
        this.ctx.fillText(line.text, line.config.x, line.config.y);
      }
    }
  },

  /**
   * Warenkorb-Integration
   */
  setupCartIntegration() {
    // Hidden Fields ins Product Form einfügen
    const productForm = document.querySelector('form[action*="/cart/add"]');

    if (productForm) {
      // Sicherstellen dass Hidden Fields im Form sind
      const hiddenFields = [
        document.getElementById('designer-hidden-line1'),
        document.getElementById('designer-hidden-line2'),
        document.getElementById('designer-hidden-line3'),
        document.getElementById('designer-hidden-line4'),
        document.getElementById('designer-hidden-font'),
        document.getElementById('designer-hidden-icon')
        // Note: Samenart wird vom V2 Picker gehandhabt
      ];

      // Geschenknotiz-Textarea aus custom_liquid Block auch ins Form verschieben
      const giftTextarea = document.getElementById('gift_msg_designer');
      if (giftTextarea && !productForm.contains(giftTextarea)) {
        // Erstelle hidden field für Gift Message im Form
        let giftHidden = document.getElementById('designer-hidden-gift');
        if (!giftHidden) {
          giftHidden = document.createElement('input');
          giftHidden.type = 'hidden';
          giftHidden.name = 'properties[Geschenknotiz]';
          giftHidden.id = 'designer-hidden-gift';
          productForm.appendChild(giftHidden);
        }
      }

      hiddenFields.forEach(field => {
        if (field && !productForm.contains(field)) {
          productForm.appendChild(field);
        }
      });

      console.log('✓ Designer hidden fields moved to product form');
    }

    // Formularfelder synchronisieren
    const fields = [
      'designer-line1',
      'designer-line2',
      'designer-line3',
      'designer-line4',
      'designer-font'
    ];

    fields.forEach(fieldId => {
      const field = document.getElementById(fieldId);
      if (field) {
        field.addEventListener('change', () => this.syncFieldsToCart());
        field.addEventListener('input', () => this.syncFieldsToCart());
        field.addEventListener('blur', () => this.syncFieldsToCart());
      }
    });

    // Icon-Auswahl synchronisieren
    document.querySelectorAll('input[name="designer-icon"]').forEach(radio => {
      radio.addEventListener('change', () => this.syncFieldsToCart());
    });

    // Schriftart-Auswahl synchronisieren
    document.querySelectorAll('input[name="font-choice"]').forEach(radio => {
      radio.addEventListener('change', () => this.syncFieldsToCart());
    });

    // Gift Message synchronisieren (aus dem custom_liquid Block)
    const giftCheckboxEl = document.getElementById('gift_check_designer');
    const giftTextareaEl = document.getElementById('gift_msg_designer');
    if (giftCheckboxEl) {
      giftCheckboxEl.addEventListener('change', () => this.syncFieldsToCart());
    }
    if (giftTextareaEl) {
      giftTextareaEl.addEventListener('input', () => this.syncFieldsToCart());
      giftTextareaEl.addEventListener('blur', () => this.syncFieldsToCart());
    }

    // Bei Form Submit synchronisieren
    if (productForm) {
      productForm.addEventListener('submit', () => {
        this.syncFieldsToCart();
      });
    }

    // Initial sync
    setTimeout(() => this.syncFieldsToCart(), 500);

    console.log('✓ Designer cart integration setup complete');
  },

  /**
   * Felder zum Warenkorb synchronisieren
   */
  syncFieldsToCart() {
    const formData = this.getFormData();

    const hiddenFields = {
      'designer-hidden-line1': formData.line1,
      'designer-hidden-line2': formData.line2,
      'designer-hidden-line3': formData.line3,
      'designer-hidden-line4': formData.line4,
      'designer-hidden-font': formData.font,
      'designer-hidden-icon': formData.iconNumber ? `Icon ${formData.iconNumber}` : ''
    };

    for (const [id, value] of Object.entries(hiddenFields)) {
      const field = document.getElementById(id);
      if (field) {
        field.value = value;
      }
    }

    // Gift Message synchronisieren (aus dem custom_liquid Block)
    const giftCheckbox = document.getElementById('gift_check_designer');
    const giftTextarea = document.getElementById('gift_msg_designer');
    const giftHidden = document.getElementById('designer-hidden-gift');
    if (giftHidden && giftTextarea) {
      giftHidden.value = (giftCheckbox && giftCheckbox.checked) ? giftTextarea.value : '';
    }

    // Samenart wird vom V2 Picker gehandhabt - bereits synchronisiert
  },

  // ========================================
  // LIVE-PREVIEW (Desktop) + FLOATING BUTTON (Mobile)
  // ========================================

  /**
   * Live-Preview initialisieren (nur Desktop)
   */
  initLivePreview() {
    this.liveCanvas = document.getElementById('live-preview-canvas');
    if (!this.liveCanvas) {
      console.log('Live-Preview: Canvas nicht gefunden (normal auf Mobile)');
      return;
    }

    this.liveCtx = this.liveCanvas.getContext('2d');

    // Input-Events für Live-Rendering
    const inputFields = ['designer-line1', 'designer-line2', 'designer-line3', 'designer-line4'];
    inputFields.forEach(id => {
      const field = document.getElementById(id);
      if (field) {
        field.addEventListener('input', () => this.debouncedLiveRender());
      }
    });

    // Font-Wechsel
    document.querySelectorAll('input[name="font-choice"]').forEach(radio => {
      radio.addEventListener('change', () => this.renderLivePreview());
    });

    // Icon-Wechsel
    document.querySelectorAll('input[name="designer-icon"]').forEach(radio => {
      radio.addEventListener('change', () => this.renderLivePreview());
    });

    // Klick auf Live-Canvas öffnet großes Modal
    this.liveCanvas.addEventListener('click', () => this.openPreview());
    this.liveCanvas.style.cursor = 'pointer';

    // Initial rendern wenn Seite geladen
    setTimeout(() => this.renderLivePreview(), 500);

    console.log('✓ Live-Preview initialisiert');
  },

  /**
   * Debounced Live-Render (für flüssiges Tippen)
   */
  debouncedLiveRender() {
    if (this.liveRenderTimeout) {
      clearTimeout(this.liveRenderTimeout);
    }
    this.liveRenderTimeout = setTimeout(() => {
      this.renderLivePreview();
    }, 100);
  },

  /**
   * Live-Preview rendern (skalierte Version)
   */
  async renderLivePreview() {
    if (!this.liveCanvas || !this.liveCtx || this.isLiveRendering) return;
    this.isLiveRendering = true;

    try {
      const formData = this.getFormData();
      const scale = this.livePreviewScale;
      const width = this.liveCanvas.width;
      const height = this.liveCanvas.height;

      // Canvas zurücksetzen
      this.liveCtx.clearRect(0, 0, width, height);

      // 1. Base-Bild zeichnen (skaliert)
      if (this.images.base && this.images.base.complete) {
        this.liveCtx.drawImage(this.images.base, 0, 0, width, height);
      }

      // 2. Icon zeichnen (skaliert)
      if (formData.iconNumber) {
        await this.drawIconOnCanvas(this.liveCtx, formData.iconNumber, scale);
      }

      // 3. Text zeichnen (skaliert)
      this.drawTextOnCanvas(this.liveCtx, formData, scale);

    } catch (error) {
      console.error('Live-Preview Rendering error:', error);
    } finally {
      this.isLiveRendering = false;
    }
  },

  /**
   * Icon auf beliebigem Canvas zeichnen
   */
  async drawIconOnCanvas(ctx, iconNumber, scale = 1) {
    const iconUrl = this.config.iconUrls[iconNumber];
    if (!iconUrl) return;

    return new Promise((resolve) => {
      const iconImg = new Image();
      iconImg.crossOrigin = 'anonymous';

      iconImg.onload = () => {
        const iconConfig = this.config.iconConfig;

        let width = iconImg.width;
        let height = iconImg.height;
        const imgScale = Math.min(
          iconConfig.maxWidth / width,
          iconConfig.maxHeight / height
        );

        width = (width * imgScale) / scale;
        height = (height * imgScale) / scale;

        const x = iconConfig.x / scale - width / 2;
        const y = iconConfig.y / scale - height / 2;

        ctx.drawImage(iconImg, x, y, width, height);
        resolve();
      };

      iconImg.onerror = () => resolve();
      iconImg.src = iconUrl;
    });
  },

  /**
   * Text auf beliebigem Canvas zeichnen
   */
  drawTextOnCanvas(ctx, formData, scale = 1) {
    const textConfig = this.config.textConfig;
    const fontData = this.config.fontConfig[formData.font];
    const fontName = fontData ? fontData.name : 'Pixie Ring';

    ctx.fillStyle = textConfig.color;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';

    const lines = [
      { text: formData.line1, config: textConfig.line1 },
      { text: formData.line2, config: textConfig.line2 },
      { text: formData.line3, config: textConfig.line3 },
      { text: formData.line4, config: textConfig.line4 }
    ];

    for (const line of lines) {
      if (line.text) {
        const fontSize = line.config.fontSize / scale;
        ctx.font = `${fontSize}px "${fontName}"`;
        ctx.fillText(line.text, line.config.x / scale, line.config.y / scale);
      }
    }
  }
};

// Auto-Initialisierung
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => DesignerPreview.init());
} else {
  DesignerPreview.init();
}
